<template>
  <base-modal overlay-class="other_modals net_prob" modal-content-class="modal_glow">
    <div class="content">
      <img src="/static/images/maintenance.png" class="" alt="Network Problem">

      <h3 class="title">{{ getTranslations.home_modals_game_maintenance_title }}</h3>

      <p>{{ getTranslations.home_modals_game_maintenance_description }}</p>

      <base-button container-class="go_to_home" @button:click="$emit('redirect:page', {pagePath: '/home'})">
        {{ getTranslations.home_modals_game_maintenance_home_page_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'

export default {
  name: 'game-maintenance',
  emits: ['redirect:page'],
  components: {
    BaseModal,
    BaseButton
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Maintenance.vue